import mitt from 'mitt';
import ConfirmDialogContainer from './ConfirmDialogContainer';

export const createConfirmDialogGlobal = (Vue, globalOptions = {}) => {
    const emitter = mitt();

    // Use prototype for Vue 2, Vue 3 it can be switched to an app level provide
    Vue.prototype.$confirmDialogEmitter = emitter;

    if (!globalOptions.useConfirmModalContainer) {
        const ConfirmDialogContainerClone = Vue.extend(ConfirmDialogContainer);

        const vm = new ConfirmDialogContainerClone().$mount();

        document.body.appendChild(vm.$el);
    }

    return (options = {}) => {
        const cleanupOnClose = () => {
            emitter.off('cancel');
            emitter.off('confirm');
        };

        emitter.emit('open', options);

        const { onConfirm, onCancel } = options;

        // use callbacks
        if (onConfirm) {
            emitter.on('cancel', () => {
                if (onCancel) {
                    onCancel();
                }
                cleanupOnClose();
            });

            emitter.on('confirm', () => {
                onConfirm();
                cleanupOnClose();
            });

            // for linting, return promise that will never resolve or reject
            return new Promise(() => {});
        }

        // use promises
        return new Promise((resolve, reject) => {
            emitter.on('cancel', () => {
                reject();
                cleanupOnClose();
            });

            emitter.on('confirm', () => {
                resolve();
                cleanupOnClose();
            });
        });
    };
};
